(function($) {
    'use strict';

    let $body = $(document.body);
    let $html = $('html');
    let $flyout_toggle = $('.flyout-toggle');
    let $flyout = $('.flyout');

    document.body.addEventListener('svm/flyout', function(event) {
        onShowFlyout(event.flyout);
    });

    $body.on('click', '.body-overlay', function(e) {
        if (e.target !== this) {
            return;
        }

        $body.trigger('flyout/hide');
    });

    $body.on('click', '.flyout-toggle', function(e) {
        e.preventDefault();

        if ($(this).hasClass('active')) {
            $body.trigger('flyout/hide');
        } else {
            onShowFlyout($(this).attr('data-flyout'));
        }

        if ($(this).hasClass('default-request-button')) {
            $('.form-bookmarks').html('');

            // Clear button cookie
            document.cookie = "offer_request_bookmark_clicked=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";

            // Reset simple form
            const label = document.querySelector('.area-wrapper');
            if (label) {
                label.style.display = '';
            }

            const grid = document.getElementById('bookmark-grid');
            if (grid) {
                grid.classList.remove('md:grid-cols-1');
                grid.classList.add('md:grid-cols-2');
            }

            // Reset Advanced form
            const labelAdvanced = document.getElementById('advanced-area-wrapper');
            if (labelAdvanced) {
                labelAdvanced.style.display = '';
            }
        }
    });

    function onShowFlyout(flyout) {
        $('body').attr('data-pos', $(window).scrollTop());
        $flyout.removeClass('active');
        $flyout_toggle.removeClass('active');
        $html.addClass('flyout-open');
        $html.attr('data-flyout', flyout);
        $('[data-flyout=' + flyout + ']').addClass('active');

        if (flyout === 'search') {
            $('#search-input').focus();
        }
    }

    class Flyout {
        constructor() {
            $body.on(
                'click',
                '.flyout-close',
                this.flyout_hide,
            );
            $(document).on('flyout/hide', this.flyout_hide);
        }

        flyout_hide = () => {
            var scrolltop = $('body').attr('data-pos');
            $(window).scrollTop(scrolltop);
            $flyout_toggle.removeClass('active');
            $flyout.removeClass('active');
            $html.removeClass('flyout-open');
            $html.removeAttr('data-flyout');
        };
    }

    new Flyout();
}(jQuery));
